import { cardsData } from '@/mocks/home';

const coverImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Dark%20editorial%20tax%20crisis%20entertainment%20news%20visual%20with%20crimson%20red%20accents%2C%20breaking%20news%20cover%2C%20dramatic%20cinematic%20lighting%2C%20dark%20mysterious%20background%2C%20professional%20media%20design&width=500&height=320&seq=card-cover-1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Dark%20regulatory%20internet%20economy%20editorial%20visual%20with%20golden%20amber%20highlights%2C%20entertainment%20news%20cover%2C%20professional%20cinematic%20style%2C%20dark%20atmospheric%20background&width=500&height=320&seq=card-cover-2&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20celebrity%20scandal%20leaked%20chats%20editorial%20visual%20with%20red%20accents%2C%20entertainment%20news%20cover%2C%20dramatic%20cinematic%20style%2C%20dark%20background&width=500&height=320&seq=card-cover-3&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Dark%20film%20industry%20crisis%20editorial%20visual%20with%20warm%20golden%20geometric%20accents%2C%20entertainment%20news%20cover%2C%20cinematic%20atmosphere%2C%20dark%20professional%20background&width=500&height=320&seq=card-cover-4&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Dark%20music%20competition%20controversy%20editorial%20visual%20with%20crimson%20highlights%2C%20entertainment%20news%20cover%2C%20dramatic%20cinematic%20style%2C%20dark%20mysterious%20background&width=500&height=320&seq=card-cover-5&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Dark%20athlete%20career%20transition%20editorial%20visual%20with%20golden%20amber%20accents%2C%20entertainment%20news%20cover%2C%20professional%20cinematic%20style%2C%20dark%20background&width=500&height=320&seq=card-cover-6&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Dark%20social%20media%20public%20relations%20editorial%20visual%20with%20red%20and%20gold%20accents%2C%20entertainment%20news%20cover%2C%20dramatic%20cinematic%20style%2C%20dark%20professional%20background&width=500&height=320&seq=card-cover-7&orientation=landscape',
};

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          精选内容
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          编辑精选，不容错过的热门爆料与深度分析
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardsData.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group block bg-background-100 border border-background-200/60 hover:border-accent-500/30 rounded-lg overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[5/3] overflow-hidden bg-background-200">
                <img
                  src={coverImages[item.id]}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs bg-accent-100 text-accent-700 px-1.5 py-0.5 rounded">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}